import CertificatePreview from './CertificatePreview';

export default CertificatePreview;
